module.exports = __webpack_public_path__ + "static/img/gf2.bcbf1cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gf2.png
// module id = y3SX
// module chunks = 1